import { Badge } from "~/components/ui/badge";
import { cn } from "~/lib/utils";
import { AccessRequestStatus } from "~/pages/manifold-nextgen/components/cohorts/interfaces/access_requests";

interface ChildDatasetAccessRequestStatusBadgeProps {
  status: AccessRequestStatus;
}

const labelByStatus: Record<AccessRequestStatus, string> = {
  [AccessRequestStatus.PENDING]: "Pending",
  [AccessRequestStatus.IN_REVIEW]: "In Review",
  [AccessRequestStatus.EXPORT_PROCESSING]: "Export Processing",
  [AccessRequestStatus.EXPORT_SUCCESSFUL]: "Export Successful",
  [AccessRequestStatus.EXPORT_FAILED]: "Export Failed",
  [AccessRequestStatus.APPROVED]: "Approved",
  [AccessRequestStatus.DENIED]: "Denied",
  [AccessRequestStatus.CANCELLED]: "Cancelled",
};

const styleByStatus: Record<AccessRequestStatus, string> = {
  [AccessRequestStatus.PENDING]: "border-yellow-400 text-yellow-700 dark:text-yellow-400",
  [AccessRequestStatus.IN_REVIEW]: "border-amber-400 text-amber-700 dark:text-amber-400",
  [AccessRequestStatus.EXPORT_PROCESSING]: "border-purple-400 text-purple-700 dark:text-purple-400",
  [AccessRequestStatus.EXPORT_SUCCESSFUL]:
    "border-emerald-400 text-emerald-700 dark:text-emerald-400",
  [AccessRequestStatus.EXPORT_FAILED]: "border-orange-400 text-orange-700 dark:text-orange-400",
  [AccessRequestStatus.APPROVED]: "border-green-400 text-green-700 dark:text-green-400",
  [AccessRequestStatus.DENIED]: "border-red-400 text-red-700 dark:text-red-400",
  [AccessRequestStatus.CANCELLED]: "border-gray-400 text-gray-500 dark:text-gray-400",
};

export const ChildDatasetAccessRequestStatusBadge = ({
  status,
}: ChildDatasetAccessRequestStatusBadgeProps) => (
  <Badge
    variant="outline"
    className={cn("rounded-full gap-1 bg-transparent", styleByStatus[status])}
  >
    <span className="size-1.5 shrink-0 rounded-full bg-current" />
    {labelByStatus[status]}
  </Badge>
);
